// extracted by mini-css-extract-plugin
export default {"main":"Legal_main__mnLIw","lastUpdated":"Legal_lastUpdated__8akE8"};